export const getRouteName = (pathname) => {
  const routeNames = {
    '/': 'Overview',
    '/dashboard': 'Dashboard',
    '/account-settings': 'Account Settings',
    '/fixed-income-flow-history': 'History',
    '/contact': 'Contact Us',
    '/login': 'Login',
    '/admin': 'Admin Panel',
    '/request-password-reset': 'Request Password Reset',
    '/reset-password': 'Reset Password'
  };

  return routeNames[pathname] || '';
};
